var Searcher = (function ($) {
    'use strict';

    function Searcher($input, urlFilter, config) {
        this.$input = $input;
        this.urlFilter = urlFilter;
        this.config = $.extend({}, this.getDefaultConfig(), config);
        this.currentValue = '';
        this.onChangeInterval = undefined;
        this.request = undefined;
        this.isMobile = false;
        this.preventQuickSearchKeywords = [];

        this.keys = {
            ESC: 27,
            TAB: 9,
            RETURN: 13,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40
        };
    }

    Searcher.prototype = {
        getDefaultConfig: function () {
            var noop = function () {};

            return {
                timeout: 250,
                beforeRequest: noop,
                onFailure: noop,
                onComplete: noop,
                onCancel: noop
            };
        },

        setPreventQuickSearchKeywords: function(keywords) {
            this.preventQuickSearchKeywords = keywords;
        },

        getConfig: function () {
            return this.config;
        },

        loadEvents: function () {
            var self = this;

            this.isMobile = /(android)/i.test(navigator.userAgent);

            // enquire.register("screen and (max-width: 767px)", {
            //     match: function () {
            //         self.isMobile = true;
            //     },
            //     unmatch: function () {
            //         self.isMobile = false;
            //     }
            // });

            this.$input.on('keydown', function (e) {
                if (e.which === self.keys.RETURN) {
                    e.preventDefault();
                    return false;
                }
            });

            this.getSubmitButton().find('.btn-search').click(function() {
                self.onValueChange();
                //self.$input.val('');
            });

            this.$input.on('keyup', function (e) {
                if( self.isMobile) {

                    if (e.which === self.keys.RETURN) {
                        self.onValueChange();
                        self.updateButton();
                        this.blur();
                    }

                    e.preventDefault();
                    return false;
                }

                switch (e.which) {
                    case self.keys.UP:
                    case self.keys.DOWN:
                        e.preventDefault();
                        return false;
                }

                if (self.onChangeInterval) {
                    clearInterval(self.onChangeInterval);
                }

                if (self.hasNewValue()) {
                    if (self.config.timeout > 0) {
                        self.onChangeInterval = setInterval(function () {
                            self.config.onCancel.call(self);
                            self.onValueChange();
                        }, self.config.timeout);
                    } else {
                        self.onValueChange();
                    }
                }

                self.updateButton();
            });
        },

        hasNewValue: function() {
            return this.currentValue !== this.$input.val();
        },

        setValue: function(value) {
            if(value) {
                this.$input.val( $.trim( value.replace(/(<([^>]+)>)/ig, '') ) );
            }
            else {
                this.$input.val('');
            }
        },

        setQuery: function (value) {
            this.setValue(value);

            this.onValueChange();
        },

        getValue: function() {
            return this.$input.val().replace(/(<([^>]+)>)/ig, '');
        },

        getUrl: function () {
            var filters = this.urlFilter.getFiltersAsString();

            if(filters) {
                return this.$input.data('url') + '/' + filters;
            }
            
            return this.$input.data('url');
        },

        onValueChange: function () {
            var
                self = this,
                value = this.getValue();

            if (this.onChangeInterval) {
                clearInterval(this.onChangeInterval);
            }

            this.currentValue = value;

            self.config.onChange.call(self, value);
        },

        getSubmitButton: function() {
            return this.$input.siblings('.input-icon-btn');
        },

        updateButton: function() {
            var $icon = this.getSubmitButton();

            if(this.$input.val() === '') {
                $icon.find('.btn-clear').hide();
                $icon.find('.btn-search').show();
            }
            else {
                $icon.find('.btn-clear').show();
                $icon.find('.btn-search').hide();
            }
        },

        isQuick: function() {
            var value = this.getValue();

            if( $.inArray(value, this.preventQuickSearchKeywords) !== -1) {
                return false;
            }

            return value.length < 3;
        }
    };

    return Searcher;
})(jQuery);
